import { PostActions } from '@/hooks/use-post-actions'
import { PendingActions } from '@/components/PostCard/components/PendingActions'
import { TimelinePost } from '@/types/post'

interface PostCardActionsProps {
  status: 'pending' | 'approved' | 'rejected'
  actions: PostActions
  isInCuration: boolean
  post: TimelinePost
}

export function PostCardActions({ status, actions, isInCuration, post }: PostCardActionsProps) {
  if (status === 'pending' && !isInCuration) {
    return <PendingActions actions={actions} post={post} />
  }
  return null
}
